import {
  PerformanceReviewerStrategiesStrategyEnum,
  UpdatePerformanceProcessTemplateReviewerStrategiesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export const useUpdatePerformanceProcessTemplateReviewerStrategies = () => {
  const [updateReviewerStrategiesMutation, { loading }] = useMutation(
    UpdatePerformanceProcessTemplateReviewerStrategiesDocument,
    {
      extractorFn: (data) =>
        data.performanceMutations.updateReviewerStrategiesPerformanceReviewProcessCustomTemplate,
    }
  )

  const updateReviewerStrategies = async (
    templateId: number,
    strategies: PerformanceReviewerStrategiesStrategyEnum[]
  ) => {
    const response = await updateReviewerStrategiesMutation({
      variables: {
        id: templateId,
        reviewerStrategies: strategies,
      },
    })
    const handled = handleResult(response, () => {})
    return { success: handled.success }
  }

  return {
    loading,
    updateReviewerStrategies,
  }
}
